$(function () {
    $('.blocklink__link__a').on('mouseenter', function () {
        $(this).parent().parent().find('.theme-fade').addClass('hovered');
    });
    $('.blocklink__link__a').on('mouseleave', function () {
        $(this).parent().parent().find('.theme-fade').removeClass('hovered');
    });
    $('.blocklink__image__inner .stretched-link').on('mouseenter', function () {
        $(this).parent().parent().parent().find('.theme-arrow').addClass('hovered');
    });
    $('.blocklink__image__inner .stretched-link').on('mouseleave', function () {
        $(this).parent().parent().parent().find('.theme-arrow').removeClass('hovered');
    });
    // copy van bovenstaand
    $('.about__vestiging__link__a').on('mouseenter', function () {
        $(this).parent().parent().find('.theme-fade').addClass('hovered');
    });
    $('.about__vestiging__link__a').on('mouseleave', function () {
        $(this).parent().parent().find('.theme-fade').removeClass('hovered');
    });
    $('.about__vestiging__image__inner .stretched-link').on('mouseenter', function () {
        $(this).parent().parent().parent().find('.theme-arrow').addClass('hovered');
    });
    $('.about__vestiging__image__inner .stretched-link').on('mouseleave', function () {
        $(this).parent().parent().parent().find('.theme-arrow').removeClass('hovered');
    });
});
